import React from "react";
import { LandingTopBar } from "./landing/LandingTopBar";
import { PortalSectionTabs } from "./PortalSectionTabs";
import { PortalToastHost } from "./PortalFormSaveBar";

export function PortalAppShell({ path, children }) {
  return (
    <div className="landing-root portal-app">
      <div className="landing-grain" aria-hidden="true" />
      <LandingTopBar variant="portal" />
      <main className="portal-app__main">
        <PortalSectionTabs path={path} />
        <div className="portal-page portal-page--app">{children}</div>
      </main>
      <PortalToastHost />
    </div>
  );
}
